module.exports = __webpack_public_path__ + "img/5.fae437cd.png";